import React, { useEffect, useState } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../components/Common/UpdatedTable"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import action from "../../assets/icons/action.svg"
import { fetchUser, updateUserStatus } from "../../services/Inventory/inventory"
import EditUser from "./edit"
import { toastError, toastSuccess } from "../../helpers/msg_helper"
import InventoryFilter from "../Inventory/filter"

const User = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Users${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;
  const [page, setPage] = useState("")

  const [series, setUser] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [count, setCount] = useState(0)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [editUser, setEditUser] = useState({ modal: false, value: "" })

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchUser({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${"&sortOrder=asc"}${page ? `&page=${page}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      setUser(response)
    }
    fetchData()
  }, [count, status, search, page, dataPerPage])

  const handleEdit = item => {
    console.log(`item`, item)
    setEditUser({ value: item, modal: true })
  }

  const handleStatus = async id => {
    try {
      const response = await updateUserStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const columns = [
    {
      label: "Name",
      renderCell: item => item?.name,
    },
    {
      label: "Email ID",
      renderCell: item => item?.email,
    },
    {
      label: "Role",
      renderCell: item => item?.roles[0]?.name,
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${
              item?.status === 1 ? "status-active" : "status-inactive"
            }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.status === 1 && (
                <div
                  className="table-popup-content"
                  onClick={() => handleEdit(item)}
                >
                  Edit
                </div>
              )}
              <div
                className={`${
                  item?.status === 1 ? "popover-border" : ""
                } table-popup-content`}
                onClick={() => handleStatus(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  const handleResetValue = () => {
    setEditUser("")
  }

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Settings"
              breadcrumbObject={[
                { title: "Settings", link: "/settings" },
                { title: "Users", link: "/settings-users" },
              ]}
            />
            <EditUser
              key={"x"}
              onUpdate={handleUpdate}
              onReset={handleResetValue}
              buttonLabel="+&nbsp; User"
              className="px-2 mb-3 me-2 btn btn-primary"
              editItem={editUser}
            />
          </div>
          <Card className="me-2 px-2 pb-2">
            <InventoryFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              sampleUrl={"download/series.xlsx"}
              importUrl={"series/import"}
              isExport={false}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                {series?.data?.data && (
                  <UpdateTable
                    className="mt-5"
                    nodes={series?.data?.data}
                    CurrentPage={page}
                    paginate={series?.data}
                    columns={columns}
                    handlePagination={handlePaginate}
                    handleSizePerPage={handleSizePerPageChange}
                    tableWidth="20% 30% 20% 20% 10%"
                    mobileWidth="40% 50% 40% 40% 20%"
                  />
                )}
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default User
